import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { WhyShopsFail } from './components/WhyShopsFail';
import { ParaisoStandard } from './components/ParaisoStandard';
import { ServicesTable } from './components/ServicesTable';
import { SocialProof } from './components/SocialProof';
import { GallerySection } from './components/GallerySection';
import { RealLifeSection } from './components/RealLifeSection';
import { LocationCTA } from './components/LocationCTA';
import { OneLiners } from './components/OneLiners';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { RecentBookingToast } from './components/RecentBookingToast';
export function App() {
  return <div className="w-full min-h-screen" style={{
    backgroundColor: '#0a0a0a'
  }} data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <div id="gallery" data-id="element-4">
          <GallerySection data-id="element-5" />
        </div>
        <div id="services" data-id="element-6">
          <PainSection data-id="element-7" />
          <WhyShopsFail data-id="element-8" />
          <ParaisoStandard data-id="element-9" />
          <ServicesTable data-id="element-10" />
        </div>
        <div id="testimonios" data-id="element-11">
          <SocialProof data-id="element-12" />
        </div>
        <RealLifeSection data-id="element-13" />
        <LocationCTA data-id="element-14" />
        <div id="faq" data-id="element-15">
          <OneLiners data-id="element-16" />
          <FAQ data-id="element-17" />
        </div>
      </main>
      <Footer data-id="element-18" />
      <RecentBookingToast data-id="element-19" />
    </div>;
}